module.exports = __webpack_public_path__ + "static/Doppelganger-746d6c9208f125518acdf8e8ae03aac7.jpg";